export const detectDeviceType = () => {
  const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const mobileWidthThreshold = 768;
  return screenWidth < mobileWidthThreshold ? 'Mobile' : 'Desktop';
}